import { useEffect } from "react"
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { AuthLayout } from "@/components/auth/AuthLayout"
import { useAuthStore } from "@/store/authStore"
import { authService } from "@/services/authService"
import { PLAN_FEATURES } from "@/lib/planFeatures"
import { hasProPlan } from "@/lib/planNames"

export function BillingSuccessPage() {
  const { setAuth } = useAuthStore()

  // Consulta até o plano pago valer: o webhook do Stripe pode levar alguns segundos
  useEffect(() => {
    let attempts = 0
    const MAX = 8
    const INTERVAL = 2000

    const poll = async () => {
      try {
        const user = await authService.me()
        setAuth(user)
        if (hasProPlan(user) || ++attempts >= MAX) return
        setTimeout(poll, INTERVAL)
      } catch {
        if (++attempts < MAX) setTimeout(poll, INTERVAL)
      }
    }

    setTimeout(poll, 1500) // espera o webhook antes da primeira consulta
  }, [setAuth])

  return (
    <AuthLayout
      pageTitle="Assinatura confirmada"
      title="Assinatura confirmada"
      description="Obrigado por assinar. A liberação leva alguns segundos e acontece sozinha."
    >
      <ul className="space-y-2.5 text-[14px]">
        {PLAN_FEATURES.pro.slice(1).map(f => (
          <li key={f} className="flex gap-2.5"><span className="text-positive-700 dark:text-positive-400" aria-hidden="true">✓</span>{f}</li>
        ))}
      </ul>
      <Button asChild size="lg" className="w-full mt-8">
        <Link to="/dashboard">Ir para o painel</Link>
      </Button>
    </AuthLayout>
  )
}
